// REDUX
import { createSlice } from "@reduxjs/toolkit";
import { getStatistics } from "api/statisticsApi";

// MISC
import { IStatisticsInitialState } from "models/interfaces";

const initialState: IStatisticsInitialState = {
  statistics: {
    recentRegisteredUsers: [],
    noOfRegisteredUsers: null,
    totalIncome: null,
    noOfCurrentDayRentals: 0,
    noOfCurrentMonthRentals: 0,
    noOfCurrentWeekRentals: 0,
    noOfCurrentYearRentals: 0,
    lockers: [],
    noOfAvailableSupBoards: 0,
    noOfTotalSupBoards: 0,
  },
  isLoading: false,
  errorMessage: "",
};

export const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStatistics.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getStatistics.fulfilled, (state, action) => {
      state.isLoading = false;
      state.statistics = action.payload;
    });
    builder.addCase(getStatistics.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
    });
  },
});

//eslint-disable-next-line
export const {} = statisticsSlice.actions;

export const statistics = (state) => state.statistics.statistics;

export default statisticsSlice.reducer;
